import { z } from 'zod'

export const sessionId = z.string().min(1)

/** A signed-in browser, as listed on the Sessions page. Times are ISO date-time strings. */
export type ActiveSession = {
  id: string
  userName: string
  userEmail: string
  userAgent: string | null
  createdAt: string
  expiresAt: string
  /** True for the session making the request. */
  current: boolean
}
